import { preparePayloadForGraphQL } from '@/helpers/validate';

/**
 * Top-level project fields of the block project-calculation ("Kalkulation – intern") with their
 * payload type (`preparePayloadForGraphQL`). Must match `ProjectCalculationInternalInput` in the
 * API schema; `createPayload` reuses the types.
 */
export const PROJECT_CALCULATION_INTERNAL_FIELD_TYPES = {
  vatPercentageState: 'number',
  generalBusinessCosts: 'number',
  profitMargin: 'number',
  costCalculationBasis: 'string',
  calculatedExternalCost: 'number',
  projectRightsCost: 'number',
  oneTimeLeaseCostDriver: 'string',
  oneTimeLeaseCostPerkWp: 'number',
  oneTimeLeaseCostPerSquareMeter: 'number',
  additionalProfitMargin: 'number',
  baseSettlementValuePerkWp: 'number',
  baseSettlementValue: 'number',
  commissionPercentage: 'number',
  calculatedProvision: 'number',
  calculatedSettlementValueDriver: 'string',
  calculatedSettlementValue: 'number',
  calculatedSettlementValuePerkWp: 'number',
};

export const PROJECT_CALCULATION_INTERNAL_INPUT_FIELDS = Object.keys(
  PROJECT_CALCULATION_INTERNAL_FIELD_TYPES
);

/** Drivers the calculation sets when a project has none (as ProjectCalculationAdvanced did). */
export const DEFAULT_ONE_TIME_LEASE_COST_DRIVER = 'PER_KWP';
export const DEFAULT_CALCULATED_SETTLEMENT_VALUE_DRIVER = 'AUTO';

/**
 * `ProjectCalculationInternalInput` from the block object (or the unsaved project), with the
 * default drivers for missing ones.
 */
export const toProjectCalculationInternalInput = (project) => {
  const input = preparePayloadForGraphQL(project, PROJECT_CALCULATION_INTERNAL_FIELD_TYPES);

  return {
    ...input,
    oneTimeLeaseCostDriver: input.oneTimeLeaseCostDriver ?? DEFAULT_ONE_TIME_LEASE_COST_DRIVER,
    calculatedSettlementValueDriver:
      input.calculatedSettlementValueDriver ?? DEFAULT_CALCULATED_SETTLEMENT_VALUE_DRIVER,
  };
};
